const Bin = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#646464"
        d="M12.135 15.729h.521a.26.26 0 0 0 .26-.26V6.614a.26.26 0 0 0-.26-.26h-.52a.26.26 0 0 0-.261.26v8.855a.26.26 0 0 0 .26.26Zm-5.208 0h.52a.26.26 0 0 0 .261-.26V6.614a.26.26 0 0 0-.26-.26h-.52a.26.26 0 0 0-.261.26v8.855a.26.26 0 0 0 .26.26Zm9.896-11.98h-3.386l-1.093-1.458a1.563 1.563 0 0 0-1.25-.624H8.49a1.563 1.563 0 0 0-1.25.625L6.146 3.75H2.76a.26.26 0 0 0-.26.26v.521a.26.26 0 0 0 .26.26h.782v11.98a1.562 1.562 0 0 0 1.562 1.562h9.375a1.562 1.562 0 0 0 1.563-1.562V4.79h.78a.26.26 0 0 0 .261-.26v-.52a.26.26 0 0 0-.26-.261Zm-8.75-.833a.524.524 0 0 1 .417-.208h2.604a.524.524 0 0 1 .416.208l.625.834H7.448l.625-.833ZM15 16.771a.521.521 0 0 1-.52.52H5.103a.521.521 0 0 1-.52-.52V4.79H15v11.98Zm-5.469-1.042h.521a.26.26 0 0 0 .26-.26V6.614a.26.26 0 0 0-.26-.26h-.52a.26.26 0 0 0-.261.26v8.855a.26.26 0 0 0 .26.26Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.5 1.667h14.583v16.667H2.5z" />
      </clipPath>
    </defs>
  </svg>
)
export default Bin
